<template>
  <div
    class="ml-1 rounded-md border-primary bg-none text-primary border py-0.5 px-1 text-sm"
  >
    <slot />
  </div>
</template>
